<template>
    <div class="page">
        <div class="header">
            <div class="header-info">
                <div class="header-avatar">
                    <!-- <img :src="avatar"> -->
                    <UserOutlined />
                </div>
                <div class="header-name">{{ userInfo.name }}</div>
            </div>
            <div class="header-button">
                <a-button size="small">服务组织</a-button>
            </div>
        </div>
        <div class="page-content">
            <div class="address">
                <p>我的地址</p>
                <p @click="handleAddress">查看全部>></p>
            </div>
            <div class="menu">
                <div class="menu-block" @click="addCommodity">
                    <img :src="icon0" />
                    <p>发布商品</p>
                </div>
                <div class="menu-block" @click="commodityEdit">
                    <img :src="icon1" />
                    <p>商品管理</p>
                </div>
                <div class="menu-block" @click="handleFeedback">
                    <img :src="icon2" />
                    <p>用户反馈</p>
                </div>
                <div class="menu-block" @click="handleLogout">
                    <img :src="icon3" />
                    <p>切换账户</p>
                </div>
            </div>
        </div>
        <bottomNav :active-code="4"></bottomNav>
    </div>
</template>

<script>
const icon0 = require("@/assets/img/icon18.png");
const icon1 = require("@/assets/img/icon19.png");
const icon2 = require("@/assets/img/icon20.png");
const icon3 = require("@/assets/img/icon21.png");
const avatar = require("@/assets/img/logo.jpeg");
import bottomNav from "@/views/public/Mall/bottomNav";
import router from "@/router";
import Cookies from "js-cookie";
import { UserOutlined } from "@ant-design/icons-vue";
export default {
    name: "Mine",
    setup() {
        const users = Cookies.get("userInfo")
        let userInfo = {name : ''}
        if (users) {
            userInfo = JSON.parse(users);
        }
        const handleAddress = () => {
            router.push({ name: "AddressList" });
        };
        const addCommodity = () => {
            router.push({ name: "AddCommodity" });
        };
        const commodityEdit = () => {
            router.push({ name: "CommodityEdit" });
        };
        const handleFeedback = () => {
            router.push({ name: "Feedback" });
        };
        const handleLogout = () => {
            Cookies.remove("userInfo")
            router.push({ name: "Login" });
        };
        return {
            icon0,
            icon1,
            icon2,
            icon3,
            avatar,
            handleAddress,
            addCommodity,
            commodityEdit,
            userInfo,
            handleFeedback,
            handleLogout
        };
    },
    components: {
        bottomNav,
        UserOutlined,
    },
};
</script>

<style scoped lang="stylus">
.page {
    width: 100%;

    .header {
        width: 100%;
        height: 180px;
        background-color: #8BC53F;
        background-image: url('../../../assets/img/mall_main_banner.png');
        background-size: 100% 100%;
        position: relative;

        .header-button {
            position: absolute;
            top: 30px;
            right: 20px;
        }

        .header-button >>> .ant-btn {
            width: 65px;
            font-size: 12px;
            color: #FFF;
            background-color: #F6721B;
            border-color: #F6721B;
            border-radius: 13px;
        }

        .header-info {
            width: 166px;
            position: absolute;
            left: calc(50% - 83px);
            top: 30px;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;

            .header-avatar {
                width: 66px;
                height: 66px;
                line-height: 66px;
                border-radius: 50%;
                overflow: hidden;
                margin-bottom: 5px;
                font-size: 35px;
                text-align: center;
                color: #626262;
                background: #F8F8F8;
            }

            .header-avatar img {
                width: 100%;
                height: 100%;
            }

            .header-name {
                width: 100%;
                text-align: center;
                font-size: 18px;
                color: #FFF;
            }
        }
    }

    .page-content {
        padding: 10px 15px;

        .address {
            width: 100%;
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            padding: 0 12px;
            background-color: #FFF;
            box-shadow: 2px -1px 8px rgba(255, 157, 91, 0.14);
            border-radius: 10px;
            display: flex;
            justify-content: space-between;
            flex-wrap: nowrap;
            font-weight: bolder;
            margin-bottom: 12px;
        }

        .address p:last-child {
            color: #949393;
            font-weight: normal;
        }

        .menu {
            width: 100%;
            height: 75px;
            background-color: #FFF;
            text-align: center;
            box-shadow: 2px -1px 8px rgba(255, 157, 91, 0.14);
            border-radius: 10px;
            display: flex;
            justify-content: space-around;
            flex-wrap: nowrap;

            .menu-block {
                margin-top: 12px;
                font-size: 12px;
                color: #676161;
            }

            .menu-block img {
                height: 30px;
                margin-bottom: 3px;
            }
        }
    }
}
</style>